/* FLOURISHING FRAGRANCES — FIND YOUR SCENT — SCENT-ONLY MATCHING
   Deterministic quiz; no external libraries, trackers, API keys, or app charges.
   Reads pre-escaped Master Scent metaobject fields rendered by the Liquid section.
   quiz_notes holds comma-separated note tags; only exact tag matches are used.
*/
(function () {
  'use strict';

  const FAMILY = {
    gourmand: { label: 'Sweet & Gourmand', words: ['gourmand', 'sweet', 'vanilla', 'marshmallow', 'caramel', 'dessert', 'bakery'] },
    fruity:   { label: 'Fruity & Playful', words: ['fruity', 'fruit', 'berry', 'berries', 'citrus', 'pear', 'apple', 'peach', 'lychee', 'dragonfruit'] },
    floral:   { label: 'Floral & Romantic', words: ['floral', 'flower', 'rose', 'jasmine', 'peony', 'blossom'] },
    fresh:    { label: 'Fresh & Clean', words: ['fresh', 'clean', 'aquatic', 'rain', 'green', 'linen', 'ozonic', 'cologne'] },
    warm:     { label: 'Warm & Cozy', words: ['warm', 'amber', 'woody', 'wood', 'musk', 'spice', 'spicy', 'cashmere'] }
  };
  const MOOD = {
    soft:     { label: 'Soft & Comforting', words: ['soft', 'comfort', 'cozy', 'gentle', 'snug'] },
    bold:     { label: 'Bold & Confident', words: ['bold', 'confident', 'strong', 'powerful', 'statement'] },
    playful:  { label: 'Fun & Flirty', words: ['playful', 'fun', 'flirty', 'cheerful', 'bright'] },
    elegant:  { label: 'Elegant & Sophisticated', words: ['elegant', 'sophisticated', 'romantic', 'luxurious', 'refined'] },
    calm:     { label: 'Relaxed & Peaceful', words: ['calm', 'peaceful', 'relax', 'serene', 'tranquil', 'spa'] }
  };

  // These labels are customer-facing; aliases are the exact allowed quiz_notes tags.
  // Example scent.quiz_notes: "vanilla, marshmallow, musk".
  const NOTE_GROUPS = [
    { value: 'vanilla', label: 'Vanilla & Marshmallow', aliases: ['vanilla', 'marshmallow'] },
    { value: 'berries', label: 'Berries', aliases: ['berries', 'berry', 'strawberry', 'raspberry', 'blueberry', 'blackberry'] },
    { value: 'tropical', label: 'Tropical Fruit', aliases: ['tropical', 'tropical fruit', 'mango', 'pineapple', 'coconut', 'passionfruit', 'dragonfruit', 'lychee'] },
    { value: 'citrus', label: 'Citrus', aliases: ['citrus', 'lemon', 'lime', 'orange', 'grapefruit', 'bergamot'] },
    { value: 'floral', label: 'Florals', aliases: ['floral', 'florals', 'rose', 'jasmine', 'peony', 'gardenia', 'lavender'] },
    { value: 'musk', label: 'Musk & Amber', aliases: ['musk', 'amber', 'musky'] },
    { value: 'woody', label: 'Woody Notes', aliases: ['wood', 'woods', 'woody', 'sandalwood', 'cedar', 'cedarwood'] },
    { value: 'clean', label: 'Clean & Airy', aliases: ['clean', 'airy', 'linen', 'aquatic', 'ozonic', 'fresh air'] }
  ];

  const QUESTIONS = [
    {
      key: 'family', setting: 'q1',
      options: Object.keys(FAMILY).map(key => ({ label: FAMILY[key].label, value: key }))
    },
    {
      key: 'mood', setting: 'q2',
      options: Object.keys(MOOD).map(key => ({ label: MOOD[key].label, value: key }))
    },
    {
      key: 'sweetness', setting: 'q3',
      options: [
        { label: 'Not sweet', value: 1 }, { label: 'A little sweet', value: 2 },
        { label: 'Somewhere in between', value: 3 }, { label: 'Pretty sweet', value: 4 },
        { label: 'Very sweet', value: 5 }, { label: 'No preference', value: 'any' }
      ]
    },
    {
      key: 'freshness', setting: 'q4',
      options: [
        { label: 'Not particularly fresh', value: 1 }, { label: 'A little fresh', value: 2 },
        { label: 'Somewhere in between', value: 3 }, { label: 'Very fresh', value: 4 },
        { label: 'Extra crisp & clean', value: 5 }, { label: 'No preference', value: 'any' }
      ]
    },
    {
      key: 'lovedNotes', setting: 'q5', multiple: true, optional: true,
      options: NOTE_GROUPS.map(group => ({ label: group.label, value: group.value }))
    },
    {
      key: 'avoidedNotes', setting: 'q6', multiple: true, optional: true,
      options: NOTE_GROUPS.map(group => ({ label: group.label, value: group.value }))
    }
  ];

  function node(tag, className, text) {
    const el = document.createElement(tag);
    if (className) el.className = className;
    if (text !== undefined) el.textContent = String(text);
    return el;
  }

  function readLevel(input) {
    if (!/^[1-5]$/.test(String(input))) return null;
    return Number(input);
  }

  function readCatalog(root) {
    const entries = root.querySelectorAll('[data-ffq-catalog] [data-ffq-scent]');
    return Array.from(entries, el => ({
      name: el.dataset.name || '',
      family: el.dataset.family || '',
      profile: el.dataset.profile || '',
      vibe: el.dataset.vibe || '',
      tags: el.dataset.tags || '',
      moods: el.dataset.moods || '',
      sweetness: readLevel(el.dataset.sweetness),
      freshness: readLevel(el.dataset.freshness),
      notes: (el.dataset.notes || '').split(',').map(tag => tag.trim().toLowerCase()).filter(Boolean),
      url: el.dataset.url || '',
      image: el.dataset.image || '',
      variants: Array.from(el.querySelectorAll('[data-ffq-variant]'), variant => ({
        title: variant.dataset.name || '',
        url: variant.dataset.url || '',
        price: variant.dataset.price || '',
        image: variant.dataset.image || ''
      })).filter(variant => variant.title && variant.url)
    })).filter(scent => scent.name && scent.url &&
       scent.sweetness !== null && scent.freshness !== null);
  }


// Match set contents by complete scent names (not substring guesses).
function scentKey(name) {
  return String(name || '').normalize('NFKC').trim().toLowerCase().replace(/\s+/g, ' ');
}

function readDiscoverySets(root) {
  const el = root.querySelector('[data-ffq-discovery-catalog]');
  if (!el) return { sets: [], productUrl: '' };
  const sets = Array.from(el.querySelectorAll('[data-ffq-discovery-set]'), entry => ({
    name: entry.dataset.name || '',
    url: entry.dataset.url || '',
    available: entry.dataset.available === 'true',
    scents: (entry.dataset.scents || '').split(',').map(name => name.trim()).filter(Boolean)
  })).filter(item => item.name && item.url && item.scents.length);
  return { sets, productUrl: el.dataset.productUrl || '' };
}

// Only call a set a personal match if it contains one of the customer's
// displayed top scent matches. Avoid suggesting a set containing a KNOWN
// disliked note group; other scents may have no quiz_notes entered yet.
function chooseDiscoverySet(sets, ranked, count) {
  const shown = ranked.slice(0, count);
  const byName = new Map(ranked.map(entry => [scentKey(entry.scent.name), entry]));
  const choices = sets.map(set => {
    const memberKeys = set.scents.map(scentKey);
    const knownAvoided = memberKeys.some(key => {
      const entry = byName.get(key);
      return !entry || entry.avoidCount > 0;
    });
    if (knownAvoided) return null;
    const overlap = shown.filter(entry =>
      entry.avoidCount === 0 && memberKeys.includes(scentKey(entry.scent.name))
    );
    if (!overlap.length) return null;
    const weighted = overlap.reduce((score, entry) => {
      const rank = shown.indexOf(entry);
      return score + Math.max(1, shown.length - rank) * 10;
    }, 0);
    return { set, overlap, weighted };
  }).filter(Boolean);
  choices.sort((a, b) =>
    b.weighted - a.weighted || b.overlap.length - a.overlap.length ||
    a.set.name.localeCompare(b.set.name)
  );
  return choices[0] || null;
}

function buildDiscoveryRecommendation(discovery, ranked, count, config) {
  if (!discovery.sets.length && !discovery.productUrl) return null;
  const picked = chooseDiscoverySet(discovery.sets, ranked, count);
  const wrapper = node('section', 'ffq__discovery');
  wrapper.setAttribute('aria-label', 'Discovery sets');
  wrapper.append(node('span', 'ffq__discovery-eyebrow', 'FOUR MINI MISTS · 8 ML EACH'));
  wrapper.append(node('h3', 'ffq__discovery-title', config.discoveryHeading || 'Try a Discovery Set'));
  if (picked) {
    wrapper.append(node('p', 'ffq__discovery-name', picked.set.name));
    const names = picked.overlap.map(item => item.scent.name);
    wrapper.append(node('p', 'ffq__discovery-match',
      names.length === 1 ? 'Includes your match: ' + names[0] : 'Includes your matches: ' + names.join(' · ')
    ));
    wrapper.append(node('p', 'ffq__discovery-scents', 'All four scents: ' + picked.set.scents.join(' · ')));
    const link = node('a', 'ffq__discovery-link', 'View this set');
    link.href = picked.set.url;
    wrapper.append(link);
    if (!picked.set.available) {
      wrapper.append(node('p', 'ffq__discovery-stock', 'Currently sold out'));
    }
  } else if (discovery.productUrl) {
    wrapper.append(node('p', 'ffq__discovery-scents', 'Explore our curated four-scent sets.'));
    const link = node('a', 'ffq__discovery-link', 'Browse discovery sets');
    link.href = discovery.productUrl;
    wrapper.append(link);
  } else {
    return null;
  }
  return wrapper;
}

  // Whole-word/phrase comparison prevents accidental substring matches,
  // such as "spa" in "sparkling" or "warm" in a longer unrelated word.
  function normalizedWords(text) {
    return ' ' + String(text || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim().replace(/\s+/g, ' ') + ' ';
  }
  function matchesAny(text, words) {
    const normalized = normalizedWords(text);
    return words.some(word => normalized.includes(normalizedWords(word)));
  }

  function hasGroup(scent, value) {
    const group = NOTE_GROUPS.find(item => item.value === value);
    return Boolean(group && group.aliases.some(alias => scent.notes.includes(alias)));
  }

  // No extra Shopify setup required: all five moods read the existing
  // Master Scent family, profile and short vibe. New scents work immediately.
  // Vibe words count more strongly than broad fragrance families.
  const MOOD_SIGNALS = {
    soft: {
      vibe: ['soft', 'cozy', 'comforting', 'creamy', 'fluffy', 'gentle', 'smooth', 'delicate', 'airy'],
      family: ['gourmand']
    },
    bold: {
      vibe: ['sultry', 'woody', 'intense', 'bold', 'spicy', 'rich', 'dark', 'deep', 'powerful'],
      family: ['masculine', 'woody', 'amber']
    },
    playful: {
      vibe: ['playful', 'juicy', 'sparkling', 'tropical', 'fruity', 'sweet', 'sugary', 'flirty', 'bright'],
      family: ['fruity']
    },
    elegant: {
      vibe: ['elegant', 'romantic', 'floral', 'musky', 'sultry', 'refined', 'luxurious', 'sophisticated'],
      family: ['floral']
    },
    calm: {
      vibe: ['calm', 'clean', 'airy', 'fresh', 'marine', 'comforting', 'dewy', 'soft', 'gentle'],
      family: ['fresh']
    }
  };

  function moodFit(scent, key) {
    const mood = MOOD[key];
    const signals = MOOD_SIGNALS[key];
    if (!mood || !signals) return 0;
    if (matchesAny(scent.moods, mood.words)) return 10;
    if (matchesAny(scent.vibe, mood.words)) return 10;
    if (matchesAny(scent.vibe, signals.vibe)) return 9;
    if (matchesAny(scent.profile, signals.family) || matchesAny(scent.family, signals.family)) return 6;
    return 0;
  }

  function evaluate(scent, answers) {
    let score = 0;
    let familyFit = 0;
    const reasons = [];
    const loved = Array.isArray(answers.lovedNotes) ? answers.lovedNotes : [];
    const avoided = Array.isArray(answers.avoidedNotes) ? answers.avoidedNotes : [];
    const family = FAMILY[answers.family];
    const mood = MOOD[answers.mood];

    if (family) {
      if (matchesAny([scent.family, scent.tags].join(' '), family.words)) {
        familyFit = 2;
        score += 18;
        reasons.push('For your ' + family.label.toLowerCase() + ' preference');
      } else if (matchesAny([scent.profile, scent.vibe].join(' '), family.words)) {
        familyFit = 1;
        score += 8;
        reasons.push('Has notes you might like');
      }
    }

    const moodPoints = moodFit(scent, answers.mood);
    score += moodPoints;
    if (!reasons.length && mood && moodPoints) {
      reasons.push('Fits your ' + mood.label.toLowerCase() + ' mood');
    }

    ['sweetness', 'freshness'].forEach(key => {
      if (answers[key] === 'any') return;
      const distance = Math.abs(scent[key] - answers[key]);
      score += Math.max(0, 6 - 2 * distance);
    });

    const lovedMatches = loved.filter(value => hasGroup(scent, value));
    const avoidMatches = avoided.filter(value => hasGroup(scent, value));
    score += lovedMatches.length * 12;
    // Avoided notes are an exclusion, not a small point penalty.
    // See rankMatches: excluded candidates never appear on result cards.
    if (!reasons.length && lovedMatches.length) {
      const label = NOTE_GROUPS.find(group => group.value === lovedMatches[0])?.label;
      if (label) reasons.push('Includes ' + label.toLowerCase() + ' notes');
    }
    if (!reasons.length) reasons.push('Close to your preferred sweetness and freshness');
    return {
      score,
      reason: reasons[0],
      familyFit,
      lovedCount: lovedMatches.length,
      avoidCount: avoidMatches.length
    };
  }

  function rankMatches(catalog, answers) {
    const familySelected = Boolean(FAMILY[answers.family]);
    const lovedSelected = Array.isArray(answers.lovedNotes) && answers.lovedNotes.length > 0;
    return catalog.map((scent, index) => ({ scent, index, ...evaluate(scent, answers) }))
      .filter(entry => entry.avoidCount === 0)
      // Don't fill remaining cards with unrelated scents just to reach three.
      .filter(entry => !familySelected || entry.familyFit > 0 || (lovedSelected && entry.lovedCount > 0))
      .sort((a, b) => b.score - a.score || b.familyFit - a.familyFit ||
        b.lovedCount - a.lovedCount || a.scent.name.localeCompare(b.scent.name) || a.index - b.index);
  }

  function buildResultCard(scent, rank, why, avoidCount) {
    const card = node('article', 'ffq__card');
    // Result cards are deliberately text-only; do not create or load scent images.
    const body = node('div', 'ffq__card-body');
    body.append(node('span', 'ffq__card-rank', rank === 1 ? 'Top match' : 'Match ' + rank));
    body.append(node('h3', 'ffq__card-title', scent.name));
    if (scent.vibe) body.append(node('p', 'ffq__card-detail', scent.vibe));
    if (scent.family && !scent.vibe) body.append(node('p', 'ffq__card-detail', scent.family));
    if (why) body.append(node('span', 'ffq__card-reason', why));
    if (avoidCount) body.append(node('span', 'ffq__card-caution', 'Includes a note category you chose to avoid.'));

    const links = node('div', 'ffq__card-links');
    scent.variants.slice(0, 4).forEach(variant => {
      const a = node('a', '', 'Shop ' + variant.title + (variant.price ? ' · ' + variant.price : ''));
      a.href = variant.url;
      links.append(a);
    });
    const explore = node('a', 'ffq__explore', 'View scent');
    explore.href = scent.url;
    links.append(explore);
    body.append(links);
    card.append(body);
    return card;
  }

  function init(root) {
    if (!root || root.dataset.ffqInitialized === 'true') return;
    root.dataset.ffqInitialized = 'true';
    const stage = root.querySelector('[data-ffq-stage]');
    const actions = root.querySelector('[data-ffq-actions]');
    const back = root.querySelector('[data-ffq-back]');
    const next = root.querySelector('[data-ffq-next]');
    const progressText = root.querySelector('[data-ffq-progress-text]');
    const progressFill = root.querySelector('[data-ffq-progress-fill]');
    const progressBar = root.querySelector('[data-ffq-progressbar]');
    const configEl = root.querySelector('[data-ffq-settings]');
    if (!stage || !actions || !back || !next || !configEl) return;

    const config = configEl.dataset;
    const catalog = readCatalog(root);
    const discovery = readDiscoverySets(root);
    const answers = {};
    let step = 0;

    function updateProgress(isComplete) {
      const percentage = isComplete ? 100 : Math.round((step + 1) / QUESTIONS.length * 100);
      progressText.textContent = isComplete ? 'Your results' : 'Question ' + (step + 1) + ' of ' + QUESTIONS.length;
      progressFill.style.width = percentage + '%';
      progressBar.setAttribute('aria-valuenow', String(percentage));
    }
    function focusTitle() {
      const heading = stage.querySelector('h2');
      if (!heading) return;
      heading.tabIndex = -1;
      try { heading.focus({ preventScroll: true }); }
      catch (_error) { heading.focus(); }
    }
    function renderQuestion(moveFocus) {
      stage.replaceChildren();
      actions.hidden = false;
      updateProgress(false);
      back.hidden = step === 0;
      const question = QUESTIONS[step];
      const selected = answers[question.key];
      next.disabled = !question.optional && (question.multiple
        ? !Array.isArray(selected) || selected.length === 0
        : selected === undefined);
      next.textContent = step === QUESTIONS.length - 1 ? 'See results' : 'Next';

      const heading = node('h2', 'ffq__question', config[question.setting] || 'Find your scent');
      heading.id = root.id + '-question';
      stage.append(heading);
      if (question.multiple) {
        stage.append(node('p', 'ffq__question-help', 'Choose any that apply, or skip.'));
      }
      const options = node('div', 'ffq__options');
      options.setAttribute('role', 'group');
      options.setAttribute('aria-labelledby', heading.id);
      const buttons = [];
      question.options.forEach(option => {
        const button = node('button', 'ffq__option');
        button.type = 'button';
        const isSelected = () => question.multiple
          ? (Array.isArray(answers[question.key]) && answers[question.key].includes(option.value))
          : answers[question.key] === option.value;
        button.setAttribute('aria-pressed', String(isSelected()));
        button.append(node('span', '', option.label));
        const indicator = node('span', 'ffq__option-indicator', isSelected() ? '✓' : '');
        indicator.setAttribute('aria-hidden', 'true');
        button.append(indicator);
        button.addEventListener('click', () => {
          if (question.multiple) {
            const current = Array.isArray(answers[question.key]) ? answers[question.key] : [];
            answers[question.key] = current.includes(option.value)
              ? current.filter(value => value !== option.value)
              : [...current, option.value];
            // Avoiding a note takes precedence if the customer later goes back
            // and adds it to the 'love' list. Prevent a contradictory selection.
            if (question.key === 'avoidedNotes' && answers.avoidedNotes.includes(option.value)) {
              answers.lovedNotes = (answers.lovedNotes || []).filter(value => value !== option.value);
            } else if (question.key === 'lovedNotes' && answers.lovedNotes.includes(option.value)) {
              answers.avoidedNotes = (answers.avoidedNotes || []).filter(value => value !== option.value);
            }
          } else {
            answers[question.key] = option.value;
          }
          buttons.forEach(other => {
            const optValue = other.dataset.ffqOption;
            const picked = question.multiple
              ? answers[question.key].includes(optValue)
              : other === button;
            other.setAttribute('aria-pressed', String(picked));
            other.querySelector('.ffq__option-indicator').textContent = picked ? '✓' : '';
          });
          next.disabled = !question.optional && question.multiple && !answers[question.key].length;
        });
        button.dataset.ffqOption = String(option.value);
        buttons.push(button);
        options.append(button);
      });
      stage.append(options);
      if (moveFocus) focusTitle();
    }

    function showResults() {
      stage.replaceChildren();
      actions.hidden = true;
      updateProgress(true);
      const scored = catalog.length ? rankMatches(catalog, answers) : [];
      const heading = !catalog.length ? config.emptyHeading :
        (scored.length ? config.resultsHeading : 'No close matches this time');
      stage.append(node('h2', 'ffq__results-title', heading));
      if (!catalog.length) {
        stage.append(node('p', 'ffq__notice', config.emptyMessage || 'Recommendations are coming soon.'));
      } else if (!scored.length) {
        stage.append(node('p', 'ffq__notice',
          'We couldn’t find a close fragrance match that fits your preferences while avoiding those notes. Try adjusting your answers or browse all scents.'));
      } else {
        stage.append(node('p', 'ffq__results-intro', config.resultsIntro));
        const grid = node('div', 'ffq__results');
        const count = Math.min(Math.max(Number(config.resultsCount) || 3, 1), 5);
        scored.slice(0, count).forEach((match, index) =>
          grid.append(buildResultCard(match.scent, index + 1, match.reason, match.avoidCount)));
        stage.append(grid);
        if (config.discoveryEnabled === 'true') {
          const recommendation = buildDiscoveryRecommendation(discovery, scored, count, config);
          if (recommendation) stage.append(recommendation);
        }
      }
      const retake = node('button', 'ffq__button ffq__button--secondary ffq__retake', 'Retake quiz');
      retake.type = 'button';
      retake.addEventListener('click', () => {
        Object.keys(answers).forEach(key => delete answers[key]);
        step = 0;
        renderQuestion(true);
      });
      stage.append(retake);
      focusTitle();
    }
    back.addEventListener('click', () => {
      if (step === 0) return;
      step -= 1;
      renderQuestion(true);
    });
    next.addEventListener('click', () => {
      if (!QUESTIONS[step].optional && answers[QUESTIONS[step].key] === undefined) return;
      if (step < QUESTIONS.length - 1) {
        step += 1;
        renderQuestion(true);
      } else {
        showResults();
      }
    });
    renderQuestion(false);
  }

  function initAll(context) {
    if (context.matches && context.matches('[data-ffq-root]')) init(context);
    context.querySelectorAll('[data-ffq-root]').forEach(init);
  }
  if (!window.__ffqListenersInstalled) {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
    document.addEventListener('shopify:section:load', event => initAll(event.target));
    window.__ffqListenersInstalled = true;
  }
  initAll(document);
})();